import React from "react";
import { View, StyleSheet } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import CustomButton from "../../../common/general/CustomButton/CustomButton";
import { Bell } from "lucide-react";
import { colors, spacing } from "../../../../styles/design-system";
import { useNavigation } from "@react-navigation/native";

export default function NotificationRedirectPanel() {
  const navigation = useNavigation<any>();

  const goToNotifications = () => {
    // navigation.navigate("Settings", { screen: "Notifications" });
  };

  return (
    <View style={styles.wrapper}>
      <View style={styles.card}>
        <CustomText
          text="Assignment reminders, SMS alerts, and other notification preferences are managed in one place."
          useTranslationText={false}
          size="s"
          style={styles.primaryText}
        />

        <CustomText
          text="Any choices you made during onboarding have already been applied there."
          useTranslationText={false}
          size="s"
          style={styles.secondaryText}
        />

        <CustomButton
          text="Go to Notifications"
          leftIcon={<Bell size={16} />}
          onPress={goToNotifications}
          styleType="secondary"
          size="s"
          style={styles.button}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    paddingHorizontal: spacing.lg,
    paddingBottom: spacing.lg,
    paddingTop: spacing.xs,
  },

  card: {
    backgroundColor: colors.grey[50],
    borderRadius: 32,
    padding: spacing.sm,
    borderWidth: 1,
    borderColor: colors.grey[200],
  },

  primaryText: {
    color: colors.grey[700],
    lineHeight: 20,
  },

  secondaryText: {
    color: colors.grey[500],
    marginTop: spacing.xxs,
    lineHeight: 20,
  },

  button: {
    marginTop: spacing.md,
    alignSelf: "flex-start",

    backgroundColor: colors.white,
    borderWidth: 1,
    borderColor: colors.grey[200],
    borderRadius: 6,

    paddingVertical: 8,
    paddingHorizontal: 16,

    shadowColor: "#101828",
    shadowOpacity: 0.1,
    shadowRadius: 3,
    shadowOffset: { width: 0, height: 1 },
    elevation: 2,
  },

  buttonText: {
    color: colors.grey[700],
    fontSize: 12,
    fontWeight: "500",
  },
});
